import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, RowsSkeletonLoader, Timeline, TimelineProps } from '@node-space/ui-components'
import { RequestErrorStatusCard } from 'components/Errors/RequestErrorStatusCard'
import { useChecklistDetails } from '../hooks/useChecklistDetails'

export const CustomerChecklist = ({ reference }: { reference: string }) => {
  const { t } = useTranslation()

  const {
    hasPendingAgreements,
    verified,
    hasPendingQuestionnaires,
    hasPendingCompanyInformation,
    questionnaireKey,
    isLoading,
    isErrorFetchingChecklist,
    refetchInfoRequired,
  } = useChecklistDetails({ reference })

  if (isLoading) {
    return <RowsSkeletonLoader rows={10} />
  }

  if (isErrorFetchingChecklist) {
    return (
      <Box paddingX={16} paddingY={32}>
        <RequestErrorStatusCard onReload={refetchInfoRequired} />
      </Box>
    )
  }

  const timelineItems: TimelineProps['items'] = [
    {
      Title: t('embeddedCustomers.timeline.agreements'),

      description: t('embeddedCustomers.timeline.agreementsDescription'),
      variant: hasPendingAgreements ? 'warning' : 'success',
    },
    {
      Title: questionnaireKey
        ? t(`embeddedCustomers.questionnaires.${questionnaireKey}`)
        : t('embeddedCustomers.questionnaires.defaultQuestionnaire'),
      variant: hasPendingQuestionnaires ? 'warning' : 'success',
      description: t('embeddedCustomers.timeline.questionnairesDescription'),
    },
    {
      Title: t('embeddedCustomers.timeline.companyInformationAndAssociates'),
      variant: hasPendingCompanyInformation ? 'warning' : 'success',
      description: t('embeddedCustomers.timeline.companyInformationAndAssociatesDescription'),
    },
    {
      Title: t('embeddedCustomers.timeline.companyVerification'),
      variant: verified ? 'success' : 'warning',
    },
  ]

  return <Timeline items={timelineItems} />
}
